<template>
  <div>
    <!-- Beneficiary dialog -->
    <v-layout justify-center>
      <v-dialog
        v-model="beneficiaryDialog"
        persistent
        max-width="600px">
        <v-card>
          <v-form
            v-model='validForm'
            ref="beneForm">
            <v-card-title>
              <span class="headline">Add Beneficiary</span>
            </v-card-title>

            <v-card-text>
              <v-container grid-list-md>
                <v-layout wrap>
                  <v-flex xs12>
                    <v-text-field
                      :rules='nameRules'
                      v-model='beneName'
                      label="Name"
                      required></v-text-field>
                  </v-flex>

                  <v-flex xs12>
                    <v-select
                      :items="['mother', 'father', 'spouse', ...relations, 'friend', 'other']"
                      v-model="beneRel"
                      label="Relationship"></v-select>
                  </v-flex>

                  <v-flex xs12>
                    <v-text-field
                      v-model='beneEmail'
                      label="Email"
                      required></v-text-field>
                  </v-flex>

                  <v-flex xs12>
                    <v-text-field
                      v-model='benePhone'
                      label="Phone"
                      required></v-text-field>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>

              <v-btn
                color="primary"
                text
                @click="
                  beneficiaryDialog = false
                  beneName = ''
                  beneRel = ''
                  beneEmail = ''
                  benePhone = ''
                ">Close</v-btn>

              <v-btn
                :disabled="!validForm"
                color="primary"
                text
                @click="addBene(),index = -1,beneficiaryDialog = false">Save</v-btn>
            </v-card-actions>
          </v-form>
        </v-card>
      </v-dialog>
    </v-layout>

    <!-- Beneficiary Form -->
    <v-card color='primary'>
      <v-layout
        column
        fill-height>
        <v-card-title class="white--text pl-5 pt-5">
          <v-spacer>Beneficiaries</v-spacer>

          <v-btn
            @click="beneficiaryDialog = true"
            class="mr-3"
            dark
            icon>
            <v-icon>mdi-account-plus</v-icon>
          </v-btn>
        </v-card-title>
      </v-layout>

      <v-list
        two-line>

        <div
          v-if='user.info.beneficiaries.length === 0'
          style='text-align: center'>
          You have no submitted beneficiaries at the moment.
        </div>

        <div
          v-for='(item, i) in user.info.beneficiaries'>
          <v-list-item>
            <v-list-item-action>
              <v-icon color="primary">mdi-account</v-icon>
            </v-list-item-action>

            <v-list-item-content>
              <v-list-item-title>{{item.name}}</v-list-item-title>
              <v-list-item-subtitle>{{item.relation}}</v-list-item-subtitle>
            </v-list-item-content>

            <v-list-item-action>
              <v-icon
                small
                @click='deleteBene(i)'>delete</v-icon>
              <div
                style='min-height: 4px'></div>
              <v-icon
                small
                @click='editBene(i)'>edit</v-icon>
            </v-list-item-action>
          </v-list-item>

          <v-divider
            v-if='!(i === user.info.beneficiaries.length-1)'
            inset></v-divider>

        </div>
      </v-list>
    </v-card>
  </div>
</template>


<script>
  import { mapFields } from 'vuex-map-fields';
  import { editUserData } from '../../helper/firestore';
  export default {
    data () {
      return {
        beneficiaryDialog: false,
        beneName: '',
        beneRel: '',
        beneEmail: '',
        benePhone: '',
        index: -1,
        validForm: false,
        nameRules: [
          v => !!v || 'A name is required'
        ],
        emailRules: [
          // v => !!v || 'E-mail is required',
          v => /.+@.+/.test(v) || 'E-mail must be valid'
        ],
        phoneRules: [
          // v => !!v || 'A phone number is required',
          v => /^[^A-z]/.test(v) || 'Please enter a valid phone number'
        ],
      }
    },
    mounted() {

    },
    methods: {
      update() {
        editUserData(this.user.info, (data) => {
          if (data.status === 200) {
            // this.snackBarType = "success"
            // this.snackBarshow = true
            // this.snackBarmessage = "Update complete"
          } else {
            // this.snackBarType = "warning"
            // this.snackBarshow = true;
            // this.snackBarmessage = "Update failed";
          }
        })
      },
      addBene() {
        if (this.index === -1) {
          this.user.info.beneficiaries.push({
            name: this.beneName,
            relation: this.beneRel,
            email: this.beneEmail,
            phone: this.benePhone
          })
          this.beneName = ''
          this.beneRel = ''
          this.beneEmail = ''
          this.benePhone = ''
        } else {
          this.user.info.beneficiaries[this.index].name = this.beneName
          this.user.info.beneficiaries[this.index].relation = this.beneRel
          this.user.info.beneficiaries[this.index].email = this.beneEmail
          this.user.info.beneficiaries[this.index].phone = this.benePhone
        }
        this.update()
        this.index = -1
      },
      editBene(i) {
        this.index = i
        this.beneName = this.user.info.beneficiaries[i].name
        this.beneRel = this.user.info.beneficiaries[i].relation
        this.beneEmail = this.user.info.beneficiaries[i].email
        this.benePhone = this.user.info.beneficiaries[i].phone
        this.beneficiaryDialog = true
      },
      deleteBene(i) {
        this.user.info.beneficiaries.splice(i, 1);
        this.update()
      }
    },
    computed: {
      ...mapFields([
        'user',
        'snackBarshow',
        'snackBarType',
        'snackBarmessage',
      ]),
      ...mapFields("patientQuestion", [
        "relations"
      ]),
    },
    components: {
    }
  }
</script>
